import 'slick-carousel';

export default () => {
	$( '.js-testimonial-slider' ).slick( {
		rows: 0,
		dots: true,
		infinite: false,
		adaptiveHeight: true,
	} );
};
